import { split, toLower } from "lodash";
import { ExportCategories, ExportField } from "PFApp/booking/types/export_booking";
import { getAPIFilters } from "PFApp/use_filtered_collection";
import { CreateTemplatePayload } from "PFCore/services/export_booking/export_booking.types";
import { useCallback } from "react";

import { useExportWizardModalContext } from "../../../export_wizard_modal_provider";
import { useReportType } from "../../use_report_type";

const mapFields = (selectedFields: ExportField[] = []): ExportCategories =>
  selectedFields.reduce((acc, curr) => {
    const [categoryKey, fieldKey] = split(curr.id, "-");
    if (categoryKey && fieldKey) {
      return {
        ...acc,
        [categoryKey]: {
          ...acc[categoryKey],
          [fieldKey]: {
            title: curr.title,
            id: curr.id
          }
        }
      };
    }
    return acc;
  }, {});

type UseTemplateRequestProviderReturn = (templateName?: string) => CreateTemplatePayload;

export const useTemplatePayloadProvider = (): UseTemplateRequestProviderReturn => {
  const {
    state: {
      data: { selectedFields, selectedFilters, frequency }
    }
  } = useExportWizardModalContext();
  const { reportType } = useReportType();

  // TODO: [PROF-2876] most likely return type is wrong
  // @ts-ignore
  return useCallback(
    (templateName) => {
      const [type, groupBy] = split(toLower(reportType), "with");
      return {
        name: templateName,
        reportType: type,
        groupBy,
        aggregateBy: frequency,
        filters: getAPIFilters(selectedFilters),
        fields: mapFields(selectedFields)
      };
    },
    [selectedFields, reportType, selectedFilters, frequency]
  );
};
